/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit NonPatient/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import BackAction from './BackAction/index'
import CloseAction from './CloseAction/index'
import Details from './Details/index'
import Email from './Email/index'
import HorizontalDivider from 'DesignSystem/HorizontalDivider/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import Phone from './Phone/index'
import Postal from './Postal/index'
import React from 'react'
import Relationship from './Relationship/index'
import SaveAction from './SaveAction/index'
import Title from './Title/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function NonPatient({
  children,
  viewPath = "/DesignSystem/DataVaxiomRelationshipsItem/Edit/NonPatient"
  
}) {
let dtSpaceXl = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xl'
        })
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 height="auto"
>
{childProps => (
<div
  data-testid="NonPatient.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<div
  data-testid="NonPatient.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Title
  viewPath={`${viewPath}/Title`}
/>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
</div>
<Relationship
  viewPath={`${viewPath}/Relationship`}
/>
<Details
  viewPath={`${viewPath}/Details`}
/>
<Postal
  viewPath={`${viewPath}/Postal`}
/>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
/>
<Phone
  viewPath={`${viewPath}/Phone`}
/>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
/>
<Email
  viewPath={`${viewPath}/Email`}
/>
<div
  data-testid="NonPatient.Horizontal:1"
  data-view-path={viewPath}
 style={{'--mt-1-Z2f6cVM': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl}}
 className={`views-block ${styles.Horizontal1}`}
>
<BackAction
  viewPath={`${viewPath}/BackAction`}
/>
<SaveAction
  viewPath={`${viewPath}/SaveAction`}
/>
</div>
</div>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}